import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    Archivos: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GENERAR_INFORME_CUMPLIMIENTO_NOM = 'GENERAR_INFORME_CUMPLIMIENTO_NOM'
const ACTUALIZAR_INFORME_CUMPLIMIENTO_NOM = 'ACTUALIZAR_INFORME_CUMPLIMIENTO_NOM'
const SUBIR_ARCHIVOS_LOTES = 'SUBIR_ARCHIVOS_LOTES'
//*******************************************************************************************************************


//MÉTODOS 

export const generarOficio = createAsyncThunk(
    GENERAR_INFORME_CUMPLIMIENTO_NOM,
    async (data) => {
        try {
            const fullUrl = host + `ArchivosUnidadInspeccion/generarOficios`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarInforme = createAsyncThunk(
    ACTUALIZAR_INFORME_CUMPLIMIENTO_NOM,
    async (data) => {
        try {
            console.log(data)
            const informe = data.informe
            let formData = new FormData();
            formData.append(0, informe)
            formData.append('idsolicitudesuifc01', data.idsolicitudesuifc01)
            formData.append('idcliente', data.idcliente)
            const fullUrl = host + `ArchivosUnidadInspeccion/actualizarInforme`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const subirArchivosLotes = createAsyncThunk(
    SUBIR_ARCHIVOS_LOTES,
    async (data) => {
        try {
            const file = data.file
            let formData = new FormData();
            formData.append(0, file)
            formData.append('idcliente', data.idcliente)
            formData.append('lote', data.lote)
            formData.append('analisis', data.analisis)
            const fullUrl = host + `ArchivosUnidadInspeccion/subirArchivosLotes`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosArchivosSlice = createSlice({

    name: 'metodosArchivosSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [generarOficio.fulfilled]: (state, { payload }) => {
            state.Archivos = payload.data.data
        },
        [actualizarInforme.fulfilled]: (state, { payload }) => {
            state.Archivos = payload.data.data
        },
        [subirArchivosLotes.fulfilled]: (state, { payload }) => {
            state.Archivos = payload.data.data
        },
    },

})


export const { } = metodosArchivosSlice.actions
export const ArchivosReducer = metodosArchivosSlice.reducer